<template>
  <div id="app">
      <v-app>
          <Header></Header>
          <v-main>
              <router-view />
          </v-main>
      </v-app>
  </div>
</template>

<script>
export default {
  components: {
  },
  watch: {
    '$route' (to, from){
      document.title = to.meta.title || 'OEAQ'
    }
  },
  mounted(){
      document.title = this.$route.meta.title || 'OEAQ'
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
